/**
 * Badge visual no canto inferior direito mostrando o ambiente (DEV vs PROD).
 * Previne confusão do tipo "estava em DEV? ou PROD?" quando navegando entre
 * subdomínios similares (admin-dev.runnaflow.com vs admin.runnaflow.com).
 *
 * Detecta via hostname — não depende de env var (poderia divergir do alias).
 * Só renderiza em DEV (PROD é o padrão, não precisa de badge).
 */
export default function EnvBadge() {
  if (typeof window === 'undefined') return null
  const host = window.location.hostname
  const isDev =
    host === 'admin-dev.runnaflow.com' ||
    host === 'runnaflow-dev.runnaflow.com' ||
    host.endsWith('.vercel.app') ||
    host === 'localhost' ||
    host === '127.0.0.1'
  if (!isDev) return null

  const label =
    host === 'admin-dev.runnaflow.com' ? 'DEV admin' :
    host === 'runnaflow-dev.runnaflow.com' ? 'DEV app' :
    host === 'localhost' || host === '127.0.0.1' ? 'LOCAL' :
    'PREVIEW'

  return (
    <div
      data-env-badge
      className="fixed right-4 z-[50] pointer-events-none select-none"
      style={{
        bottom: 'calc(1rem + var(--mobile-bottom-bar-pad, 0px))',
        padding: '3px 8px',
        borderRadius: '6px',
        background: 'color-mix(in oklch, var(--color-accent-orange) 20%, transparent)',
        border: '1px solid color-mix(in oklch, var(--color-accent-orange) 45%, transparent)',
        color: 'var(--color-accent-orange)',
        fontSize: '10px',
        fontWeight: 700,
        letterSpacing: '0.08em',
        fontFamily: 'var(--font-mono, ui-monospace, monospace)',
        textTransform: 'uppercase',
      }}
      title={`Runnaflow environment: ${host}`}
    >
      {label}
    </div>
  )
}
